var cov_1pw44m6aat = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldSet.tsx",
      hash = "9e8e666c6d0d4f472f3c6de1350640976d9ffe0b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldSet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 31
        },
        end: {
          line: 11,
          column: 99
        }
      },
      "1": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 42
        }
      },
      "2": {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 42
        }
      },
      "3": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 30
        }
      },
      "4": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 30
        }
      },
      "5": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "6": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 45
        }
      },
      "7": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 44
        }
      },
      "8": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 54
        }
      },
      "9": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "10": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "11": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "12": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 29
        }
      },
      "13": {
        start: {
          line: 42,
          column: 46
        },
        end: {
          line: 42,
          column: 56
        }
      },
      "14": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 72
        }
      },
      "15": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 32
        }
      },
      "16": {
        start: {
          line: 48,
          column: 32
        },
        end: {
          line: 48,
          column: 42
        }
      },
      "17": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 45
        }
      },
      "18": {
        start: {
          line: 53,
          column: 32
        },
        end: {
          line: 53,
          column: 42
        }
      },
      "19": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 54,
          column: 37
        }
      },
      "20": {
        start: {
          line: 55,
          column: 17
        },
        end: {
          line: 55,
          column: 37
        }
      },
      "21": {
        start: {
          line: 56,
          column: 26
        },
        end: {
          line: 56,
          column: 102
        }
      },
      "22": {
        start: {
          line: 56,
          column: 55
        },
        end: {
          line: 56,
          column: 101
        }
      },
      "23": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 32
        }
      },
      "24": {
        start: {
          line: 59,
          column: 16
        },
        end: {
          line: 59,
          column: 45
        }
      },
      "25": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 49
        }
      },
      "26": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 56
        }
      },
      "27": {
        start: {
          line: 62,
          column: 28
        },
        end: {
          line: 62,
          column: 56
        }
      },
      "28": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "29": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 26
        }
      },
      "30": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 19
        }
      },
      "31": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 27
        }
      },
      "32": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 31
        }
      },
      "33": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "34": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 24
        }
      },
      "35": {
        start: {
          line: 83,
          column: 41
        },
        end: {
          line: 83,
          column: 51
        }
      },
      "36": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 66
        }
      },
      "37": {
        start: {
          line: 84,
          column: 60
        },
        end: {
          line: 84,
          column: 66
        }
      },
      "38": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 41
        }
      },
      "39": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 31
        }
      },
      "40": {
        start: {
          line: 86,
          column: 17
        },
        end: {
          line: 86,
          column: 31
        }
      },
      "41": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 56
        }
      },
      "42": {
        start: {
          line: 90,
          column: 26
        },
        end: {
          line: 90,
          column: 56
        }
      },
      "43": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 97,
          column: 6
        }
      },
      "44": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 96,
          column: 7
        }
      },
      "45": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 26
        }
      },
      "46": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 95,
          column: 33
        }
      },
      "47": {
        start: {
          line: 101,
          column: 32
        },
        end: {
          line: 101,
          column: 42
        }
      },
      "48": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 40
        }
      },
      "49": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 29
        }
      },
      "50": {
        start: {
          line: 107,
          column: 32
        },
        end: {
          line: 107,
          column: 42
        }
      },
      "51": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 33
        }
      },
      "52": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 29
        }
      },
      "53": {
        start: {
          line: 113,
          column: 32
        },
        end: {
          line: 113,
          column: 42
        }
      },
      "54": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 45
        }
      },
      "55": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 41
        }
      },
      "56": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 115,
          column: 41
        }
      },
      "57": {
        start: {
          line: 119,
          column: 63
        },
        end: {
          line: 119,
          column: 73
        }
      },
      "58": {
        start: {
          line: 121,
          column: 19
        },
        end: {
          line: 121,
          column: 43
        }
      },
      "59": {
        start: {
          line: 122,
          column: 19
        },
        end: {
          line: 122,
          column: 21
        }
      },
      "60": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 131,
          column: 5
        }
      },
      "61": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 130,
          column: 7
        }
      },
      "62": {
        start: {
          line: 133,
          column: 17
        },
        end: {
          line: 133,
          column: 58
        }
      },
      "63": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 59
        }
      },
      "64": {
        start: {
          line: 134,
          column: 42
        },
        end: {
          line: 134,
          column: 59
        }
      },
      "65": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 156,
          column: 5
        }
      },
      "66": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 136,
          column: 57
        }
      },
      "67": {
        start: {
          line: 138,
          column: 24
        },
        end: {
          line: 138,
          column: 83
        }
      },
      "68": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 155,
          column: 8
        }
      },
      "69": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 154,
          column: 9
        }
      },
      "70": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 160,
          column: 5
        }
      },
      "71": {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 159,
          column: 60
        }
      },
      "72": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 17
        }
      },
      "73": {
        start: {
          line: 166,
          column: 33
        },
        end: {
          line: 179,
          column: 1
        }
      },
      "74": {
        start: {
          line: 168,
          column: 44
        },
        end: {
          line: 179,
          column: 1
        }
      },
      "75": {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 178,
          column: 13
        }
      },
      "76": {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 176,
          column: 8
        }
      },
      "77": {
        start: {
          line: 181,
          column: 32
        },
        end: {
          line: 181,
          column: 40
        }
      }
    },
    fnMap: {
      "0": {
        name: "extendName",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 19
          }
        },
        loc: {
          start: {
            line: 17,
            column: 107
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 20
          },
          end: {
            line: 21,
            column: 21
          }
        },
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 44
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 43
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 22
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        loc: {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 40
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 56,
            column: 50
          },
          end: {
            line: 56,
            column: 51
          }
        },
        loc: {
          start: {
            line: 56,
            column: 55
          },
          end: {
            line: 56,
            column: 101
          }
        },
        line: 56
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        },
        loc: {
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 68,
            column: 7
          }
        },
        line: 65
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        },
        loc: {
          start: {
            line: 69,
            column: 11
          },
          end: {
            line: 72,
            column: 7
          }
        },
        line: 69
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 23
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 76
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 77,
            column: 25
          },
          end: {
            line: 77,
            column: 26
          }
        },
        loc: {
          start: {
            line: 77,
            column: 31
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 77
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 29
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 82
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 104
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 89
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 91,
            column: 34
          },
          end: {
            line: 91,
            column: 35
          }
        },
        loc: {
          start: {
            line: 91,
            column: 40
          },
          end: {
            line: 97,
            column: 5
          }
        },
        line: 91
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 44
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 100
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        loc: {
          start: {
            line: 106,
            column: 30
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 106
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 62
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 112
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        loc: {
          start: {
            line: 118,
            column: 11
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 118
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 139,
            column: 21
          },
          end: {
            line: 139,
            column: 22
          }
        },
        loc: {
          start: {
            line: 139,
            column: 54
          },
          end: {
            line: 155,
            column: 7
          }
        },
        line: 139
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 166,
            column: 33
          },
          end: {
            line: 166,
            column: 34
          }
        },
        loc: {
          start: {
            line: 168,
            column: 44
          },
          end: {
            line: 179,
            column: 1
          }
        },
        line: 168
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 168,
            column: 44
          },
          end: {
            line: 168,
            column: 45
          }
        },
        loc: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 178,
            column: 13
          }
        },
        line: 169
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 170,
            column: 5
          },
          end: {
            line: 170,
            column: 6
          }
        },
        loc: {
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 176,
            column: 8
          }
        },
        line: 171
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 20
          },
          end: {
            line: 17,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 37
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 42
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 42
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 30
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 30
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 19
          },
          end: {
            line: 23,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 23,
            column: 37
          },
          end: {
            line: 23,
            column: 40
          }
        }, {
          start: {
            line: 23,
            column: 43
          },
          end: {
            line: 23,
            column: 45
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 55
          },
          end: {
            line: 56,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 55
          },
          end: {
            line: 56,
            column: 76
          }
        }, {
          start: {
            line: 56,
            column: 80
          },
          end: {
            line: 56,
            column: 101
          }
        }],
        line: 56
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 21
          },
          end: {
            line: 59,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 21
          },
          end: {
            line: 59,
            column: 37
          }
        }, {
          start: {
            line: 59,
            column: 41
          },
          end: {
            line: 59,
            column: 43
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 56
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 56
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 66
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 66
          }
        }],
        line: 84
      },
      "9": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 31
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 31
          }
        }],
        line: 86
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 56
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 56
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 96,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 96,
            column: 7
          }
        }, {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 96,
            column: 7
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 92,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 10
          },
          end: {
            line: 92,
            column: 29
          }
        }, {
          start: {
            line: 92,
            column: 33
          },
          end: {
            line: 92,
            column: 52
          }
        }, {
          start: {
            line: 92,
            column: 56
          },
          end: {
            line: 92,
            column: 80
          }
        }],
        line: 92
      },
      "13": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 115,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 115,
            column: 41
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 115,
            column: 41
          }
        }],
        line: 115
      },
      "14": {
        loc: {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        }, {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 131,
            column: 5
          }
        }],
        line: 124
      },
      "15": {
        loc: {
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 128,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 128,
            column: 34
          }
        }, {
          start: {
            line: 128,
            column: 38
          },
          end: {
            line: 128,
            column: 79
          }
        }],
        line: 128
      },
      "16": {
        loc: {
          start: {
            line: 133,
            column: 17
          },
          end: {
            line: 133,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 17
          },
          end: {
            line: 133,
            column: 36
          }
        }, {
          start: {
            line: 133,
            column: 40
          },
          end: {
            line: 133,
            column: 52
          }
        }, {
          start: {
            line: 133,
            column: 56
          },
          end: {
            line: 133,
            column: 58
          }
        }],
        line: 133
      },
      "17": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 59
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 59
          }
        }],
        line: 134
      },
      "18": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 18
          },
          end: {
            line: 134,
            column: 40
          }
        }],
        line: 134
      },
      "19": {
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }, {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }],
        line: 135
      },
      "20": {
        loc: {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 27
          }
        }, {
          start: {
            line: 135,
            column: 31
          },
          end: {
            line: 135,
            column: 36
          }
        }],
        line: 135
      },
      "21": {
        loc: {
          start: {
            line: 138,
            column: 25
          },
          end: {
            line: 138,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 49
          },
          end: {
            line: 138,
            column: 55
          }
        }, {
          start: {
            line: 138,
            column: 58
          },
          end: {
            line: 138,
            column: 66
          }
        }],
        line: 138
      },
      "22": {
        loc: {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        }, {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 160,
            column: 5
          }
        }],
        line: 158
      },
      "23": {
        loc: {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 170,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 170,
            column: 22
          },
          end: {
            line: 170,
            column: 24
          }
        }],
        line: 170
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/FieldSet.tsx",
    _this6 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import createReactContext from '../context';
import { Component } from '../component';
import { filterProps } from '../utils/objects';
import _validate from '../utils/validate';
import { wrapFormError, isSameError } from '../utils/errors';
import { ERROR_TYPE, FORCE_PASS, IGNORE_VALIDATE } from '../Datum/types';
import FieldError from './FieldError';

var _ref = (cov_1pw44m6aat.s[0]++, createReactContext(undefined)),
    Provider = _ref.Provider,
    Consumer = _ref.Consumer;

function extendName() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1pw44m6aat.b[0][0]++, '');
  var name = arguments.length > 1 ? arguments[1] : undefined;
  cov_1pw44m6aat.f[0]++;
  cov_1pw44m6aat.s[1]++;

  if (name === undefined) {
    cov_1pw44m6aat.b[1][0]++;
    cov_1pw44m6aat.s[2]++;
    return undefined;
  } else {
    cov_1pw44m6aat.b[1][1]++;
  }

  cov_1pw44m6aat.s[3]++;

  if (name === '') {
    cov_1pw44m6aat.b[2][0]++;
    cov_1pw44m6aat.s[4]++;
    return path;
  } else {
    cov_1pw44m6aat.b[2][1]++;
  }

  cov_1pw44m6aat.s[5]++;

  if (Array.isArray(name)) {
    cov_1pw44m6aat.b[3][0]++;
    cov_1pw44m6aat.s[6]++;
    return name.map(function (n) {
      cov_1pw44m6aat.f[1]++;
      cov_1pw44m6aat.s[7]++;
      return extendName(path, n);
    });
  } else {
    cov_1pw44m6aat.b[3][1]++;
  }

  cov_1pw44m6aat.s[8]++;
  return "".concat(path).concat(path.length > 0 ? (cov_1pw44m6aat.b[4][0]++, '.') : (cov_1pw44m6aat.b[4][1]++, '')).concat(name);
}

var FieldSet =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldSet, _Component);

  var _super = _createSuper2(FieldSet);

  function FieldSet(props) {
    var _this;

    _classCallCheck(this, FieldSet);

    cov_1pw44m6aat.f[2]++;
    cov_1pw44m6aat.s[9]++;
    _this = _super.call(this, props);
    _this.updateTimer = void 0;
    cov_1pw44m6aat.s[10]++;
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    cov_1pw44m6aat.s[11]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FieldSet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1pw44m6aat.f[3]++;
      cov_1pw44m6aat.s[12]++;

      _get(_getPrototypeOf(FieldSet.prototype), "componentDidMount", this).call(this);

      var _ref2 = (cov_1pw44m6aat.s[13]++, this.props),
          formDatum = _ref2.formDatum,
          name = _ref2.name,
          defaultValue = _ref2.defaultValue;

      cov_1pw44m6aat.s[14]++;
      formDatum.bind(name, this.handleUpdate, defaultValue, this.validate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1pw44m6aat.f[4]++;
      cov_1pw44m6aat.s[15]++;

      _get(_getPrototypeOf(FieldSet.prototype), "componentWillUnmount", this).call(this);

      var _ref3 = (cov_1pw44m6aat.s[16]++, this.props),
          formDatum = _ref3.formDatum,
          name = _ref3.name;

      cov_1pw44m6aat.s[17]++;
      formDatum.unbind(name, this.handleUpdate);
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this2 = this;

      cov_1pw44m6aat.f[5]++;

      var _ref4 = (cov_1pw44m6aat.s[18]++, this.props),
          formDatum = _ref4.formDatum,
          name = _ref4.name;

      var value = (cov_1pw44m6aat.s[19]++, formDatum.get(name));
      var data = (cov_1pw44m6aat.s[20]++, formDatum.getValue());
      var validateProps = (cov_1pw44m6aat.s[21]++, filterProps(this.props, function (v) {
        cov_1pw44m6aat.f[6]++;
        cov_1pw44m6aat.s[22]++;
        return (cov_1pw44m6aat.b[5][0]++, typeof v === 'string') || (cov_1pw44m6aat.b[5][1]++, typeof v === 'number');
      })); // @ts-ignore

      cov_1pw44m6aat.s[23]++;
      validateProps.type = 'array';
      var rules = (cov_1pw44m6aat.s[24]++, _toConsumableArray((cov_1pw44m6aat.b[6][0]++, this.props.rules) || (cov_1pw44m6aat.b[6][1]++, [])));
      cov_1pw44m6aat.s[25]++;
      rules = rules.concat(formDatum.getRule(name));
      cov_1pw44m6aat.s[26]++;

      if (rules.length === 0) {
        cov_1pw44m6aat.b[7][0]++;
        cov_1pw44m6aat.s[27]++;
        return Promise.resolve(true);
      } else {
        cov_1pw44m6aat.b[7][1]++;
      }

      cov_1pw44m6aat.s[28]++;
      return _validate(value, data, rules, validateProps).then(function () {
        cov_1pw44m6aat.f[7]++;
        cov_1pw44m6aat.s[29]++;

        _this2.handleError();

        cov_1pw44m6aat.s[30]++;
        return true;
      }, function (e) {
        cov_1pw44m6aat.f[8]++;
        cov_1pw44m6aat.s[31]++;

        _this2.handleError(e);

        cov_1pw44m6aat.s[32]++;
        return wrapFormError(e);
      });
    }
  }, {
    key: "updateWithValidate",
    value: function updateWithValidate() {
      var _this3 = this;

      cov_1pw44m6aat.f[9]++;
      cov_1pw44m6aat.s[33]++;
      this.validate().then(function () {
        cov_1pw44m6aat.f[10]++;
        cov_1pw44m6aat.s[34]++;

        _this3.forceUpdate();
      });
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      cov_1pw44m6aat.f[11]++;

      var _ref5 = (cov_1pw44m6aat.s[35]++, this.props),
          formDatum = _ref5.formDatum,
          name = _ref5.name,
          onError = _ref5.onError;

      cov_1pw44m6aat.s[36]++;

      if (isSameError(error, formDatum.getError(name, true))) {
        cov_1pw44m6aat.b[8][0]++;
        cov_1pw44m6aat.s[37]++;
        return;
      } else {
        cov_1pw44m6aat.b[8][1]++;
      }

      cov_1pw44m6aat.s[38]++;
      formDatum.setError(name, error, true);
      cov_1pw44m6aat.s[39]++;

      if (onError) {
        cov_1pw44m6aat.b[9][0]++;
        cov_1pw44m6aat.s[40]++;
        onError(error);
      } else {
        cov_1pw44m6aat.b[9][1]++;
      }
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(_v, _n, type) {
      var _this4 = this;

      cov_1pw44m6aat.f[12]++;
      cov_1pw44m6aat.s[41]++;

      if (this.updateTimer) {
        cov_1pw44m6aat.b[10][0]++;
        cov_1pw44m6aat.s[42]++;
        clearTimeout(this.updateTimer);
      } else {
        cov_1pw44m6aat.b[10][1]++;
      }

      cov_1pw44m6aat.s[43]++;
      this.updateTimer = setTimeout(function () {
        cov_1pw44m6aat.f[13]++;
        cov_1pw44m6aat.s[44]++;

        if ((cov_1pw44m6aat.b[12][0]++, type === ERROR_TYPE) || (cov_1pw44m6aat.b[12][1]++, type === FORCE_PASS) || (cov_1pw44m6aat.b[12][2]++, type === IGNORE_VALIDATE)) {
          cov_1pw44m6aat.b[11][0]++;
          cov_1pw44m6aat.s[45]++;

          _this4.forceUpdate();
        } else {
          cov_1pw44m6aat.b[11][1]++;
          cov_1pw44m6aat.s[46]++;

          _this4.updateWithValidate();
        }
      });
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(index, value) {
      cov_1pw44m6aat.f[14]++;

      var _ref6 = (cov_1pw44m6aat.s[47]++, this.props),
          formDatum = _ref6.formDatum,
          name = _ref6.name;

      cov_1pw44m6aat.s[48]++;
      formDatum.insert(name, index, value);
      cov_1pw44m6aat.s[49]++;
      this.updateWithValidate();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(index) {
      cov_1pw44m6aat.f[15]++;

      var _ref7 = (cov_1pw44m6aat.s[50]++, this.props),
          formDatum = _ref7.formDatum,
          name = _ref7.name;

      cov_1pw44m6aat.s[51]++;
      formDatum.splice(name, index);
      cov_1pw44m6aat.s[52]++;
      this.updateWithValidate();
    }
  }, {
    key: "handleChange",
    value: function handleChange(index, value, update) {
      cov_1pw44m6aat.f[16]++;

      var _ref8 = (cov_1pw44m6aat.s[53]++, this.props),
          formDatum = _ref8.formDatum,
          name = _ref8.name;

      cov_1pw44m6aat.s[54]++;
      formDatum.set("".concat(name, "[").concat(index, "]"), value);
      cov_1pw44m6aat.s[55]++;

      if (update) {
        cov_1pw44m6aat.b[13][0]++;
        cov_1pw44m6aat.s[56]++;
        this.updateWithValidate();
      } else {
        cov_1pw44m6aat.b[13][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      cov_1pw44m6aat.f[17]++;

      var _ref9 = (cov_1pw44m6aat.s[57]++, this.props),
          children = _ref9.children,
          formDatum = _ref9.formDatum,
          name = _ref9.name,
          empty = _ref9.empty,
          defaultValue = _ref9.defaultValue;

      var errors = (cov_1pw44m6aat.s[58]++, formDatum.getError(name));
      var result = (cov_1pw44m6aat.s[59]++, []);
      cov_1pw44m6aat.s[60]++;

      if (typeof children !== 'function') {
        cov_1pw44m6aat.b[14][0]++;
        cov_1pw44m6aat.s[61]++;
        return (
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              path: name,
              val: this.validate
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 126,
              columnNumber: 9
            }
          }, children, (cov_1pw44m6aat.b[15][0]++, errors instanceof Error) && (cov_1pw44m6aat.b[15][1]++,
          /*#__PURE__*/
          React.createElement(FieldError, {
            key: "error",
            error: errors,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 128,
              columnNumber: 39
            }
          })))
        );
      } else {
        cov_1pw44m6aat.b[14][1]++;
      }

      var values = (cov_1pw44m6aat.s[62]++, (cov_1pw44m6aat.b[16][0]++, formDatum.get(name)) || (cov_1pw44m6aat.b[16][1]++, defaultValue) || (cov_1pw44m6aat.b[16][2]++, []));
      cov_1pw44m6aat.s[63]++;

      if ((cov_1pw44m6aat.b[18][0]++, values) && (cov_1pw44m6aat.b[18][1]++, !Array.isArray(values))) {
        cov_1pw44m6aat.b[17][0]++;
        cov_1pw44m6aat.s[64]++;
        values = [values];
      } else {
        cov_1pw44m6aat.b[17][1]++;
      }

      cov_1pw44m6aat.s[65]++;

      if ((cov_1pw44m6aat.b[20][0]++, values.length === 0) && (cov_1pw44m6aat.b[20][1]++, empty)) {
        cov_1pw44m6aat.b[19][0]++;
        cov_1pw44m6aat.s[66]++;
        result.push(empty(this.handleInsert.bind(this, 0)));
      } else {
        cov_1pw44m6aat.b[19][1]++;
        var errorList = (cov_1pw44m6aat.s[67]++, (Array.isArray(errors) ? (cov_1pw44m6aat.b[21][0]++, errors) : (cov_1pw44m6aat.b[21][1]++, [errors])).filter(Boolean));
        cov_1pw44m6aat.s[68]++;
        values.forEach(function (v, i) {
          cov_1pw44m6aat.f[18]++;
          cov_1pw44m6aat.s[69]++;
          result.push(
          /*#__PURE__*/
          React.createElement(Provider, {
            key: i,
            value: {
              path: "".concat(name, "[").concat(i, "]"),
              val: _this5.validate
            },
            __self: _this5,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 141,
              columnNumber: 11
            }
          }, children({
            list: values,
            value: v,
            index: i,
            error: errorList,
            datum: formDatum,
            onChange: _this5.handleChange.bind(_this5, i),
            onInsert: _this5.handleInsert.bind(_this5, i),
            onAppend: _this5.handleInsert.bind(_this5, i + 1),
            onRemove: _this5.handleRemove.bind(_this5, i)
          })));
        });
      }

      cov_1pw44m6aat.s[70]++;

      if (errors instanceof Error) {
        cov_1pw44m6aat.b[22][0]++;
        cov_1pw44m6aat.s[71]++;
        result.push(
        /*#__PURE__*/
        React.createElement(FieldError, {
          key: "error",
          error: errors,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 159,
            columnNumber: 19
          }
        }));
      } else {
        cov_1pw44m6aat.b[22][1]++;
      }

      cov_1pw44m6aat.s[72]++;
      return result;
    }
  }]);

  return FieldSet;
}(Component);

FieldSet.defaultProps = {
  rules: []
};
cov_1pw44m6aat.s[73]++;
export var fieldSetConsumer = function fieldSetConsumer(Origin) {
  cov_1pw44m6aat.f[19]++;
  cov_1pw44m6aat.s[74]++;
  return function (props) {
    cov_1pw44m6aat.f[20]++;
    cov_1pw44m6aat.s[75]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this6,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 169,
          columnNumber: 3
        }
      }, function () {
        var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1pw44m6aat.b[23][0]++, {}),
            path = _ref10.path,
            val = _ref10.val;

        cov_1pw44m6aat.f[21]++;
        cov_1pw44m6aat.s[76]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            name: extendName(path, props.name),
            innerFormNamePath: path,
            fieldSetValidate: val,
            __self: _this6,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 171,
              columnNumber: 7
            }
          }))
        );
      })
    );
  };
};
export var FieldSetProvider = (cov_1pw44m6aat.s[77]++, Provider);
export default fieldSetConsumer(FieldSet);